import TIM from 'tim-js-sdk';
import {imsdk} from '@/config/index'
let options = {
  SDKAppID: imsdk 
};
let tim = TIM.create(options);

tim.setLogLevel(1);

export default tim;